import { Injectable, type Provider } from '@angular/core';

import { ok, type ApiResult } from '../../../core/models/api-result';
import type { PlaceBoardPage, PlaceGame, PlaceTopEntry } from './hub-place.models';
import { HubPlaceService } from './hub-place.service';

/**
 * THE PLACE HERO, WITHOUT A SESSION (`/preview/hubs`, `hubs.home-v2`).
 *
 * Top here and the game board are viewer-scoped, so the guard-free harness
 * answers from memory. Rum Runner Works (`?hub=bhm`) has two Top here stories
 * that open real posts in the corpus; every other hub has none (and so shows
 * its pins, if any). The office card and the heads-ups come from Dean's Home
 * preview services (`hubs-rail-preview`, `hubs-heads-up-preview`).
 *
 * Small and inline, unlike the feed corpus: this file is imported as a value
 * by `app.routes.ts`, so it lands in the eager bundle and must stay light.
 */

const now = () => new Date();
const inDays = (days: number) => new Date(now().getTime() + days * 86_400_000).toISOString();

function slot(
  id: string,
  itemId: string,
  title: string,
  kind: string,
  art: string,
  endsInDays: number,
): PlaceTopEntry {
  return {
    kind: 'SLOT',
    reason: 'SITE',
    reasonText: 'Top here, picked by the people who run this hub.',
    slot: {
      id,
      order: 0,
      priority: 'FEATURED',
      panelArt: null,
      panelLabel: null,
      strapline: null,
      liveEventId: null,
      liveEvent: null,
      external: null,
      target: 'CONTENT',
      itemId,
      item: { id: itemId, title, kind, hasMedia: true, mediaUrl: art, posterUrl: null, playbackUrl: null },
      ackPolicy: null,
      viewerAcknowledgedAt: null,
      window: { startsAt: inDays(-1), endsAt: inDays(endsInDays) },
    },
  };
}

const TOP_HERE: Record<string, PlaceTopEntry[]> = {
  bhm: [
    slot('top-terrace', 'bhm-4', 'The roof terrace is open, and the heaters arrive Thursday', 'Photo', '/assets/hubs-preview/snap-roof-terrace.jpg', 4),
    slot('top-level3', 'bhm-1', 'Where everything moved on Level 3', 'Article', '/assets/hubs-preview/pro-reception.jpg', 9),
  ],
};

@Injectable()
export class HubPlacePreviewService extends HubPlaceService {
  protected override async fetchTopHere(hubId: string): Promise<ApiResult<readonly PlaceTopEntry[] | null>> {
    return ok(TOP_HERE[hubId] ?? []);
  }

  protected override async fetchApps(): Promise<
    ApiResult<readonly { key: string; installed: boolean; enabled: boolean }[] | null>
  > {
    return ok([]);
  }

  protected override async fetchGames(): Promise<ApiResult<readonly PlaceGame[] | null>> {
    return ok([]);
  }

  protected override async fetchBoard(): Promise<ApiResult<PlaceBoardPage | null>> {
    return ok(null);
  }
}

export const HUB_PLACE_PREVIEW_PROVIDER: Provider = {
  provide: HubPlaceService,
  useClass: HubPlacePreviewService,
};
